export default __webpack_public_path__ + "static/media/logo_square.741bee63.png";